var _path, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationFlowIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 52,
    viewBox: "0 0 11 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.63895 38.0017C2.90009 37.9336 0.529587 39.9655 0.0764113 42.7695C-0.376765 45.5735 1.22523 48.2968 3.8356 49.1598L5.0976 50.9983C5.18385 51.1241 5.32308 51.1991 5.4718 51.2C5.61958 51.1999 5.75842 51.1265 5.84543 51.0025L7.13461 49.1682C9.70508 48.3353 11.3179 45.6951 10.9472 42.9271C10.5764 40.1591 8.33087 38.0755 5.63895 38.0017Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 21.5,
    r: 1.5,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 15.5,
    r: 1.5,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 27.5,
    r: 1.5,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 33.5,
    r: 1.5,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationFlowIcons);
export default __webpack_public_path__ + "static/media/location-flow-icons.d76ce402def4f04be6c768ef85083dae.svg";
export { ForwardRef as ReactComponent };